export default "__VITE_ASSET__CXP9U7bE__"